import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const DashboardLayoutContext = createContext(null);

export const useDashboardLayout = () => {
  const context = useContext(DashboardLayoutContext);

  if (!context) {
    throw new Error(
      "useDashboardLayout doit être utilisé dans DashboardLayoutProvider"
    );
  }

  return context;
};

export function DashboardLayoutProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    return localStorage.getItem("mac_dashboard_sidebar_collapsed") === "1";
  });

  useEffect(() => {
    localStorage.setItem(
      "mac_dashboard_sidebar_collapsed",
      isCollapsed ? "1" : "0"
    );
  }, [isCollapsed]);

  const value = useMemo(
    () => ({
      isCollapsed,
      setIsCollapsed,
      toggleSidebar: () => setIsCollapsed((prev) => !prev),
    }),
    [isCollapsed]
  );

  return (
    <DashboardLayoutContext.Provider value={value}>
      {children}
    </DashboardLayoutContext.Provider>
  );
}